import { Layout } from '@/components/common/Layout/Layout';
import { Button } from '@/components/ui/button';
import { Clock, AlarmClock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex flex-col items-center justify-center min-h-[70vh] max-w-3xl mx-auto text-center">
        <div className="relative mb-6">
          <Clock className="h-32 w-32 text-muted-foreground opacity-40" />
          <AlarmClock className="h-16 w-16 text-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
        </div>
        
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <h2 className="text-3xl font-semibold mb-2">Time has gone missing!</h2>
        
        <p className="text-xl text-muted-foreground mb-6">
          Looks like this page got lost in a time warp. Even our best time trackers couldn't log where it went!
        </p>
        
        <div className="max-w-md mx-auto space-y-4">
          <p className="text-muted-foreground italic">
            "Time is what we want most, but what we use worst." — William Penn
          </p>
          
          <Button 
            size="lg" 
            onClick={() => navigate('/dashboard')} 
            className="gap-2 mt-8 text-lg px-8 py-6"
          >
            Go to Dashboard
            <ArrowRight className="h-5 w-5 ml-1" />
          </Button>
        </div>
      </div>
    </Layout>
  );
}